import {
  PersonnelProvider,
  ResponderMapProvider,
  TourProvider,
  ZonesProvider,
} from 'features/Responder';
import { SchedulesProvider } from 'features/Responder/features/Schedules/contexts/SchedulesContext';
import AssignmentBuilder from 'features/Responder/features/Schedules/features/Assignments/components/AssignmentBuilder';
import { AssignmentsProvider } from 'features/Responder/features/Schedules/features/Assignments/contexts/AssignmentsContext';
import ScheduleList from 'features/Responder/features/Schedules/features/ScheduleList';
import React, { useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Group, Panel } from 'react-resizable-panels';
import { ResizablePanelHandle } from 'utils/panelResizeUtils';

function AssignmentLayout() {
  const pageRef = useRef(null);
  const [pageHeight, setPageHeight] = useState(null);

  return (
    <div
      ref={pageRef}
      className="tour-builder-page py-4"
      style={{
        minHeight: 0,
        height: pageHeight ? `${pageHeight}px` : '100vh',
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Container fluid className="d-flex flex-column" style={{ flex: 1, minHeight: 0 }}>
        {/* <header className="mb-4 text-white">
          
          <h2 className="fw-bold mb-1">Tour Builder</h2>
          <p className="text-muted mb-0">
            Build a tour by combining checkpoints and verify route data in
            real-time.
          </p>
        </header> */}

        <Row className="flex-grow-1" style={{ minHeight: 0 }}>
          <Col className="d-flex flex-column h-100" style={{ minHeight: 0 }}>
            <Group
              orientation="horizontal"
              className="d-flex w-100 flex-grow-1 h-100"
              style={{ minHeight: 0, height: '100%' }}
            >
              <Panel
                defaultSize={70}
                minSize={40}
                className="d-flex flex-column h-100"
                style={{ minHeight: 0 }}
              >
                <div className="card border-0 shadow-lg bg-dark text-white h-100">
                  <div className="card-body rounded overflow-hidden p-0 h-100">
                    <div className="position-relative w-100 h-100">
                      <div className="w-100 h-100 rounded-top overflow-hidden">
                        <AssignmentBuilder />
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>

              <ResizablePanelHandle direction="vertical" />

              <Panel
                defaultSize={30}
                minSize={20}
                className="d-flex flex-column h-100"
                style={{ minHeight: 0 }}
              >
                <ScheduleList type="assignment" />
              </Panel>
            </Group>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default function Assignments() {
  return (
    <PersonnelProvider>
      <TourProvider>
        <ZonesProvider>
          <ResponderMapProvider>
            <SchedulesProvider>
              <AssignmentsProvider>
                <AssignmentLayout />
              </AssignmentsProvider>
            </SchedulesProvider>
          </ResponderMapProvider>
        </ZonesProvider>
      </TourProvider>
    </PersonnelProvider>
  );
}
